[
  {
    "name": "$ae_crashed_reason",
    "displayName": "Crash Reason",
    "description": "The explanation of why the app crashed.",
    "type": "string",
    "exampleValue": "Exception in thread 'main' java.lang.NullPointerException\""
  },
  {
    "name": "$ae_first_app_open_date",
    "displayName": "First App Open Date",
    "description": "The date of the first time the app is opened.",
    "type": "datetime",
    "exampleValue": "2018/07/16 09:07:21.205-07:00"
  },
  {
    "name": "$ae_iap_name",
    "displayName": "Product Name",
    "description": "The name of the in-app purchase.",
    "type": "string",
    "exampleValue": "Socks, game tokens"
  },
  {
    "name": "$ae_iap_price",
    "displayName": "Product Price",
    "description": "The price of the in-app purchase.",
    "type": "number",
    "exampleValue": "126.99"
  },
  {
    "name": "$ae_iap_quantity",
    "displayName": "Product Quantity",
    "description": "The number of items in an in-app purchase.",
    "type": "number",
    "exampleValue": "3,600"
  },
  {
    "name": "$ae_notif_message",
    "displayName": "Message"
  },
  {
    "name": "$ae_session_length",
    "displayName": "Session Length",
    "description": "The number of seconds the user spent in the session.",
    "type": "number",
    "exampleValue": "54"
  },
  {
    "name": "$ae_total_app_session_length",
    "displayName": "Total App Session Length",
    "description": "The amount of time in seconds from when the user launches the app until the user stops using or leaves the app.",
    "type": "number",
    "exampleValue": "120"
  },
  {
    "name": "$ae_total_app_sessions",
    "displayName": "Total App Sessions",
    "description": "The total number of \"App Session\" events that the user has sent.",
    "type": "number",
    "exampleValue": "3"
  },
  {
    "name": "$ae_updated_version",
    "displayName": "Version Updated",
    "description": "The new version number after an update from a previous version.",
    "type": "string",
    "exampleValue": "2.7, 3.5.1"
  },
  {
    "name": "$android_app_version",
    "displayName": "Android App Version",
    "description": "The current android app version code",
    "type": "string",
    "exampleValue": "1.1.11"
  },
  {
    "name": "$android_app_version_code",
    "displayName": "Android App Version Code",
    "description": "The current app version.",
    "type": "number",
    "exampleValue": "34"
  },
  {
    "name": "$android_brand",
    "displayName": "Android Brand",
    "description": "The brand of the Android device.",
    "type": "string",
    "exampleValue": "Samsung"
  },
  {
    "name": "$android_devices",
    "displayName": "Android Devices",
    "description": "The list of a user's Google Cloud Messaging registration IDs for Android push. Mixpanel's Android client library has methods to manage this property for you.",
    "type": "string",
    "exampleValue": "fZIXwzi232984vu78392z789c"
  },
  {
    "name": "$android_lib_version",
    "displayName": "Android Lib Version",
    "description": "Version of the Mixpanel Android library used to send this data",
    "type": "string"
  },
  {
    "name": "$android_manufacturer",
    "type": "string"
  },
  {
    "name": "$android_model",
    "displayName": "Android Model",
    "description": "The Android device model.",
    "type": "string",
    "exampleValue": "Pixel"
  },
  {
    "name": "$android_notification_id",
    "displayName": "Android Notification Id",
    "description": "The canonical notification identifier that was used for the push notification. This value is used to determine whether the device should add a new notification or replace an existing notification.",
    "type": "string",
    "exampleValue": "998297913, my_custom_id"
  },
  {
    "name": "$android_os",
    "displayName": "Android OS",
    "description": "The Android operating system.",
    "type": "string",
    "exampleValue": "Android"
  },
  {
    "name": "$android_os_version",
    "displayName": "Android OS Version",
    "description": "Current Android version for this device.",
    "type": "string",
    "exampleValue": "8.1.0"
  },
  {
    "name": "$android_push_error",
    "type": "string"
  },
  {
    "name": "$anon_id",
    "displayName": "Anonymous ID",
    "description": "Internal Mixpanel property to track the anonymous ID passed into the identify method.",
    "type": "string",
    "exampleValue": "abc123",
    "hidden": true
  },
  {
    "name": "$answer_count",
    "displayName": "Answer Count"
  },
  {
    "name": "$answers",
    "description": "Deprecated",
    "type": "list"
  },
  {
    "name": "$app_build_number",
    "displayName": "App Build Number",
    "description": "The general build of this app.",
    "type": "string",
    "exampleValue": "31, 32, 36"
  },
  {
    "name": "$app_release",
    "displayName": "App Release",
    "description": "Deprecated",
    "type": "string"
  },
  {
    "name": "$app_version",
    "displayName": "App Version",
    "description": "Deprecated",
    "type": "string",
    "hidden": true
  },
  {
    "name": "$app_version_string",
    "displayName": "App Version",
    "description": "The current app version.",
    "type": "string",
    "exampleValue": "1.1, 1.11"
  },
  {
    "name": "$bluetooth_enabled",
    "displayName": "Bluetooth Enabled",
    "description": "The Bluetooth app is enabled. Bluetooth icon is green when enabled and grey when not enabled.",
    "type": "boolean",
    "exampleValue": "true"
  },
  {
    "name": "$bluetooth_version",
    "displayName": "Bluetooth Version",
    "description": "The version of the Bluetooth that is running on the device. Set to \"none\", \"ble\", or \"classic\".",
    "type": "string",
    "exampleValue": "ble"
  },
  {
    "name": "$bounce_category",
    "displayName": "Bounce Category",
    "description": "An email that an email server rejects as either a soft or hard bounce category. Soft bounces are emails that are rejected for temporary delivery reasons. hard bounces indicate that one should never try to send to that email again.",
    "type": "string",
    "exampleValue": "Soft bounce: \"rate limit has been reached\". Hard bounce: \"example@test.com\" is an invalid domain.\""
  },
  {
    "name": "$bounce_notification",
    "type": "string"
  },
  {
    "name": "$bounced",
    "type": "datetime"
  },
  {
    "name": "$bounced_reason",
    "type": "string"
  },
  {
    "name": "$brand",
    "displayName": "Brand",
    "description": "The brand of the device.",
    "type": "string",
    "exampleValue": "Pixel, Samsung"
  },
  {
    "name": "$browser",
    "displayName": "Browser",
    "description": "The browser being used at the time the event was fired. (Not versioned)",
    "type": "string",
    "exampleValue": "Chrome, Safari"
  },
  {
    "name": "$browser_version",
    "displayName": "Browser Version",
    "description": "The version number of the browser being used at the time the event was fired.",
    "type": "string",
    "exampleValue": "11, 11.1"
  },
  {
    "name": "$bucket",
    "displayName": "Bucket",
    "description": "A reserved property that is hidden from the Mixpanel interface, and will cause other events to not appear in the interface. Do not name any property bucket or $bucket."
  },
  {
    "name": "$button_id",
    "displayName": "Button Id",
    "description": "The customer-defined identifier for the push notification action button that was tapped.",
    "type": "string",
    "exampleValue": "shop_cta"
  },
  {
    "name": "$button_label",
    "displayName": "Button Label",
    "description": "The label of the push notification action button that was tapped.",
    "type": "string",
    "exampleValue": "Shop Now"
  },
  {
    "name": "$cancelled",
    "type": "string"
  },
  {
    "name": "$captured_for_heatmap",
    "displayName": "Captured for Heatmap",
    "description": "Indicates whether this event was captured specifically for heatmap visualization",
    "type": "boolean",
    "exampleValue": "true",
    "hidden": true
  },
  {
    "name": "$carrier",
    "displayName": "Carrier",
    "description": "The wireless carrier of the device owner.",
    "type": "string",
    "exampleValue": "AT&T"
  },
  {
    "name": "$clientX",
    "displayName": "[Auto] Client X",
    "description": "The X-coordinate of the mouse pointer relative to the browser's viewport when the event occurred.",
    "type": "number",
    "exampleValue": "100"
  },
  {
    "name": "$clientY",
    "displayName": "[Auto] Client Y",
    "description": "The Y-coordinate of the mouse pointer relative to the browser's viewport when the event occurred.",
    "type": "number",
    "exampleValue": "100"
  },
  {
    "name": "$created",
    "displayName": "Created",
    "description": "The time that the profile was created.",
    "type": "datetime",
    "exampleValue": "2018-01-01T00:00:00"
  },
  {
    "name": "$current_url",
    "displayName": "Current URL",
    "description": "The full URL of the webpage on which the event is triggered.",
    "type": "string",
    "exampleValue": "https://mixpanel.com/example/"
  },
  {
    "name": "$dataset",
    "displayName": "Project Name"
  },
  {
    "name": "$device",
    "displayName": "Device",
    "description": "The name of the event sender's device, if they're on mobile web.",
    "type": "string",
    "exampleValue": "Android, iPhone"
  },
  {
    "name": "$device_id",
    "displayName": "Device ID",
    "description": "A default Mixpanel property to track the device as determined by Mixpanel's client-side SDKs. Events tracked from the same device and same user but different applications may not have the same $device_id. The reset method will change the device_id.",
    "type": "string"
  },
  {
    "name": "$distinct_id",
    "displayName": "Distinct ID",
    "description": "The way to uniquely identify your users. You can set this to any value using the identify method. Some Mixpanel libraries assign a random value by default.",
    "type": "string",
    "exampleValue": "166424e227e7fb-0ff2f469b2f1fc-2d6a4f35",
    "isSensitiveBlacklisted": true
  },
  {
    "name": "$distinct_id_before_identity",
    "displayName": "Distinct ID Before Identity",
    "description": "Internal Mixpanel property to track an events original $distinct_id before it updated due to $identify, $merge, or $alias. Only events that were copied over the canonical identifier have this property set. This property can be used to determine an event's $distinct_id before it was merged.",
    "type": "string",
    "exampleValue": "123abc",
    "hidden": true,
    "isSensitiveBlacklisted": true
  },
  {
    "name": "$duration",
    "displayName": "Duration",
    "description": "A property that is appended to a session-end event to indicate how long a session lasts in seconds.",
    "type": "number",
    "exampleValue": "90081"
  },
  {
    "name": "$duration_s",
    "displayName": "Session Duration (Seconds)",
    "description": "The duration between Session Start and Session End events in seconds.",
    "type": "number",
    "exampleValue": "413"
  },
  {
    "name": "$el_attr__href",
    "displayName": "[Auto] Link target",
    "description": "HTML href attribute of an element that the user has interacted with.",
    "type": "string"
  },
  {
    "name": "$elements",
    "displayName": "[Auto] Elements",
    "description": "A list of elements that were involved in the event, useful for understanding element context.",
    "type": "list"
  },
  {
    "name": "$el_classes",
    "displayName": "[Auto] Element Classes",
    "description": "HTML classes of an element that the user has interacted with.",
    "type": "list"
  },
  {
    "name": "$el_id",
    "displayName": "[Auto] Element ID",
    "description": "HTML ID of an element that the user has interacted with.",
    "type": "string"
  },
  {
    "name": "$el_tag_name",
    "displayName": "[Auto] Element Tag Name",
    "description": "HTML tag name of an element that the user has interacted with.",
    "type": "string",
    "exampleValue": "div"
  },
  {
    "name": "$el_text",
    "displayName": "[Auto] Element Text",
    "description": "Text content of an element that the user has interacted with.",
    "type": "string"
  },
  {
    "name": "$event_count",
    "displayName": "Session Event Count",
    "description": "The number of events during a session. This does not include Excluded Events and Hidden Events in Lexicon.",
    "type": "number",
    "exampleValue": "103"
  },
  {
    "name": "$event_name",
    "displayName": "Event Name",
    "description": "Name of the event",
    "type": "string",
    "exampleValue": "Song Played"
  },
  {
    "name": "$event_type",
    "displayName": "[Auto] Event Type",
    "description": "The type of DOM event that was captured (e.g., “click”, “submit”).",
    "type": "string",
    "exampleValue": "click, submit"
  },
  {
    "name": "$events_distinct_id",
    "description": "distinct_id is a unique identifier that is connected to every event as an event property.",
    "type": "string"
  },
  {
    "name": "$experiment_id",
    "displayName": "Experiment ID",
    "description": "The specific experiment the user saw.",
    "type": "number",
    "exampleValue": "3243"
  },
  {
    "name": "$experiments",
    "displayName": "Experiments",
    "description": "The list of all experiments and variants a user has been exposed to as a super property.",
    "type": "object",
    "exampleValue": "{\"4233\": 1353, \"24234\": 2564}"
  },
  {
    "name": "$failure_description",
    "displayName": "Failure Description",
    "description": "Mixpanel property explaining why an operation was not executed in detail",
    "type": "string",
    "exampleValue": "Identified and anon ID are same in the identify request 1495269"
  },
  {
    "name": "$failure_reason",
    "displayName": "Failure Reason",
    "description": "Mixpanel property summarizing why an operation was not executed",
    "type": "string",
    "exampleValue": "errSameIDs"
  },
  {
    "name": "$from_binding",
    "displayName": "From Binding",
    "description": "The specific codeless mobile event.",
    "type": "string",
    "exampleValue": "Purchase button clicked"
  },
  {
    "name": "$from_preview",
    "displayName": "Sent as preview",
    "description": "Whether or not the push notification was sent as a preview from the Mixpanel UI",
    "type": "boolean"
  },
  {
    "name": "$geo_source",
    "displayName": "Geo Source",
    "description": "Internal Mixpanel property to record the source used to determine location",
    "type": "string",
    "exampleValue": "reverse_geocoding",
    "hidden": true
  },
  {
    "name": "$google_play_services",
    "displayName": "Google Play Services",
    "description": "Whether Google Play Services is available or not in the device",
    "type": "string",
    "exampleValue": "available, missing"
  },
  {
    "name": "$had_persisted_distinct_id",
    "displayName": "Had Persisted Distinct Id",
    "type": "boolean",
    "exampleValue": "true",
    "mixpanelHidden": true
  },
  {
    "name": "$has_nfc",
    "displayName": "Has NFC",
    "description": "The device supports Near Field Communication(NFC). Set to true if the device has NFC, false if not.",
    "type": "boolean",
    "exampleValue": "true"
  },
  {
    "name": "$has_telephone",
    "displayName": "Has Telephone",
    "description": "Verifies the mobile phone device is functional. Set to true if this device has telephone functionality, false if not.",
    "type": "boolean",
    "exampleValue": "true"
  },
  {
    "name": "$host",
    "displayName": "Host",
    "description": "The name of the web host.",
    "type": "string",
    "exampleValue": "mixpanel.com"
  },
  {
    "name": "$histogram",
    "displayName": "Distribution"
  },
  {
    "name": "$identified_id",
    "displayName": "Identified ID",
    "description": "Internal Mixpanel property to track the identifier passed into the identify method.",
    "type": "string",
    "exampleValue": "123abc",
    "hidden": true
  },
  {
    "name": "$identity_failure_reason",
    "displayName": "Identity Failure Reason",
    "description": "Mixpanel property summarizing why identity management could not process the event's identity operation.",
    "type": "string",
    "exampleValue": "errAnonDistinctIdAssignedAlready"
  },
  {
    "name": "$ignore_time",
    "description": "The \"$last_seen\" property reflects the timestamp of the last update to any people property, so server-side calls also overwrite and result in all your users showing the same timestamp for \"last seen\". To avoid an overwrite, add in the \"$ignore_time\" property to the people call.",
    "type": "boolean"
  },
  {
    "name": "$import",
    "displayName": "Import"
  },
  {
    "name": "$initial_referrer",
    "displayName": "Initial Referrer",
    "description": "The referring URL at first arrival.",
    "type": "string",
    "exampleValue": "$direct, https://www.google.com/"
  },
  {
    "name": "$initial_referring_domain",
    "displayName": "Initial Referring Domain",
    "description": "The referring domain at first arrival.",
    "type": "string",
    "exampleValue": "$direct, www.google.com"
  },
  {
    "name": "$insert_id",
    "displayName": "Insert ID",
    "description": "A random 36 character string of hyphenated alphanumeric characters that is unique to an event. Used to deduplicate events.",
    "type": "string",
    "exampleValue": "5d958f87-542d-4c10-9422-0ed75893dc81",
    "hidden": true
  },
  {
    "name": "$ios_app_release",
    "displayName": "iOS App Release",
    "description": "The iOS app release name.",
    "type": "string",
    "exampleValue": "3.20.1"
  },
  {
    "name": "$ios_app_version",
    "displayName": "iOS App Version",
    "description": "The iOS app release version.",
    "type": "string"
  },
  {
    "name": "$ios_device_model",
    "displayName": "iOS Device Model",
    "description": "The model ID of the device.",
    "type": "string",
    "exampleValue": "iPad 3,4"
  },
  {
    "name": "$ios_devices",
    "displayName": "iOS Devices",
    "description": "The list of a user's Apple Push Notification service device tokens for iOS push. The Mixpanel iOS client library has methods to manage this property for you.",
    "type": "list",
    "exampleValue": "[\"125c634a2cd5944c357938f92e76c\"]"
  },
  {
    "name": "$ios_ifa",
    "displayName": "iOS IFA",
    "description": "The iOS identifier for advertisers.",
    "type": "string",
    "exampleValue": "2A12329E-95X9-4712-9F86-561C53101X56"
  },
  {
    "name": "$ios_lib_version",
    "displayName": "iOS Lib Version",
    "description": "The Mixpanel library that is used to send this data.",
    "type": "string",
    "exampleValue": "2.0"
  },
  {
    "name": "$ios_notification_id",
    "displayName": "iOS Notification Id",
    "description": "The canonical notification identifier that was used for the push notification. This value is used to determine whether the device should add a new notification or replace an existing notification.",
    "type": "string",
    "exampleValue": "91FE1952-63E0-4A71-90B4-BE29E025B4FC, my_custom_id"
  },
  {
    "name": "$ios_version",
    "displayName": "iOS Version",
    "description": "The current version of iOS on the device.",
    "type": "number",
    "exampleValue": "26510"
  },
  {
    "name": "$ip_hash",
    "description": "A hash of the ip for trends purposes",
    "type": "string",
    "exampleValue": "125c634a2cd5944c357938f92e76c",
    "mixpanelHidden": true
  },
  {
    "name": "$is_reshuffled",
    "description": "Internal Mixpanel property to identify if the event data is currently shuffled due to a recent identity merge",
    "type": "boolean",
    "exampleValue": "true",
    "mixpanelHidden": true
  },
  {
    "name": "$last_login",
    "displayName": "Last login",
    "description": "The time of the last login of a user.",
    "type": "datetime"
  },
  {
    "name": "$last_seen",
    "displayName": "Updated at",
    "description": "Timestamp of the last profile update.",
    "type": "datetime",
    "exampleValue": "2012-11-20T15:26:19"
  },
  {
    "name": "$last_successful_email",
    "type": "number"
  },
  {
    "name": "$lib_version",
    "displayName": "Library Version",
    "description": "Version of the Mixpanel library used to enqueue or send this data.",
    "type": "string",
    "exampleValue": "5.4.1"
  },
  {
    "name": "$list_length",
    "displayName": "Size"
  },
  {
    "name": "$list_sum",
    "displayName": "Sum"
  },
  {
    "name": "$list_unique",
    "displayName": "Distinct Count"
  },
  {
    "name": "$manufacturer",
    "displayName": "Manufacturer",
    "description": "The manufacturer of the device.",
    "type": "string",
    "exampleValue": "Apple, Samsung"
  },
  {
    "name": "$marked_spam",
    "type": "datetime"
  },
  {
    "name": "$mixed",
    "displayName": "Metric"
  },
  {
    "name": "$model",
    "displayName": "Model",
    "description": "The model of the device.",
    "type": "string",
    "exampleValue": "iPhone10,6, Pixel 2 XL"
  },
  {
    "name": "$mp_api_endpoint",
    "displayName": "API Endpoint",
    "description": "Internal Mixpanel property to record the API endpoint the data was sent to",
    "type": "string",
    "exampleValue": "api.mixpanel.com",
    "hidden": true
  },
  {
    "name": "$mp_api_timestamp_ms",
    "displayName": "API Timestamp",
    "description": "Unix time stamp in milliseconds when an event hits Mixpanel API. While the \"Time\" property in Mixpanel is set in the time zone specified by the project, mp_api_timestamp_ms will always be in UTC (GMT) time. The calculated difference between $mp_api_timestamp_ms and mp_processing_time_ms can show the ingestion delay.",
    "type": "number",
    "exampleValue": "1543546310165",
    "hidden": true
  },
  {
    "name": "$mp_autocapture",
    "displayName": "Autocapture Event",
    "description": "Whether the current event was tracked by the Autocapture SDK feature.",
    "type": "boolean",
    "exampleValue": "true"
  },
  {
    "name": "$mp_event_size",
    "displayName": "Event Size",
    "description": "The size, in bytes, of this event before transformation",
    "type": "number",
    "exampleValue": "1543",
    "hidden": true
  },
  {
    "name": "$mp_first_event_time",
    "displayName": "First Seen",
    "description": "Internal Mixpanel property that represents the time of the users first event in mixpanel",
    "type": "datetime",
    "exampleValue": "2012-11-20T15:26:19"
  },
  {
    "name": "$mp_replay_id",
    "displayName": "Replay ID",
    "description": "ID of a screen recording that was being captured in the browser tab which tracked this event",
    "type": "string",
    "exampleValue": "2024-02-23/54eb82d4ca230b-0ad95068e100fe-1e525637-384000-54eb82e5ca450b"
  },
  {
    "name": "replay_length_ms",
    "displayName": "Replay Length (ms)",
    "description": "The total duration of a replay in ms. This is not useful for querying because checkpoints for a replay are tracked many times while it progresses, so this value constantly increases for the same replay ID.",
    "type": "number",
    "exampleValue": "120000",
    "mixpanelHidden": true
  },
  {
    "name": "replay_env",
    "displayName": "Replay Environment",
    "description": "The environment in which the replay was recorded.",
    "type": "string",
    "exampleValue": "prod",
    "mixpanelHidden": true
  },
  {
    "name": "replay_region",
    "displayName": "Replay Region",
    "description": "The geographic region where the replay was captured.",
    "type": "string",
    "exampleValue": "us"
  },
  {
    "name": "replay_start_time",
    "displayName": "Replay Start Time",
    "description": "The Unix epoch time in seconds when the replay started.",
    "type": "number",
    "exampleValue": "1685622896",
    "mixpanelHidden": true
  },
  {
    "name": "replay_version",
    "displayName": "Replay Version",
    "description": "The version of the replay recording format.",
    "type": "string",
    "exampleValue": "1",
    "mixpanelHidden": true
  },
  {
    "name": "replay_start_url",
    "displayName": "Replay Start URL",
    "description": "The URL where the replay session started.",
    "type": "string",
    "exampleValue": "https://mixpanel.com/dashboard"
  },
  {
    "name": "$neighborhood",
    "type": "string"
  },
  {
    "name": "$notifications",
    "type": "list"
  },
  {
    "name": "$offsetX",
    "displayName": "[Auto] Offset X",
    "description": "The X-coordinate of the mouse pointer relative to the event target element.",
    "type": "number",
    "exampleValue": "100"
  },
  {
    "name": "$offsetY",
    "displayName": "[Auto] Offset Y",
    "description": "The Y-coordinate of the mouse pointer relative to the event target element.",
    "type": "number",
    "exampleValue": "100"
  },
  {
    "name": "$origin_end",
    "displayName": "Session End Event Name",
    "description": "The original event name that triggered Session End event.",
    "type": "string",
    "exampleValue": "Sign Out, Complete Purchase,"
  },
  {
    "name": "$origin_start",
    "displayName": "Session Start Event Name",
    "description": "The original event name that triggered Session Start event.",
    "type": "string",
    "exampleValue": "Sign In, View Pricing, Landing Page"
  },
  {
    "name": "$os",
    "displayName": "Operating System",
    "description": "The operating system of the event sender.",
    "type": "string",
    "exampleValue": "Mac OS X, Windows"
  },
  {
    "name": "$os_version",
    "displayName": "OS Version",
    "description": "The current version of operating system on the device.",
    "type": "string",
    "exampleValue": "11.4, 11.4.1"
  },
  {
    "name": "$pageHeight",
    "displayName": "[Auto] Page Height",
    "description": "The height of the entire page.",
    "type": "number",
    "exampleValue": "968"
  },
  {
    "name": "$pageWidth",
    "displayName": "[Auto] Page Width",
    "description": "The width of the entire page.",
    "type": "number",
    "exampleValue": "1920"
  },
  {
    "name": "$pageX",
    "displayName": "[Auto] Page X",
    "description": "The X-coordinate of the mouse pointer relative to the entire page.",
    "type": "number",
    "exampleValue": "100"
  },
  {
    "name": "$pageY",
    "displayName": "[Auto] Page Y",
    "description": "The Y-coordinate of the mouse pointer relative to the entire page.",
    "type": "number",
    "exampleValue": "100"
  },
  {
    "name": "$pathname",
    "displayName": "Path Name",
    "description": "The pathname of the URL of the page on which the event was fired.",
    "type": "string",
    "exampleValue": "/path/to/page, /url/path/"
  },
  {
    "name": "$predict_event",
    "displayName": "Predict event",
    "description": "An event chosen to predict its conversion behavior.",
    "type": "string",
    "exampleValue": "Buy Song"
  },
  {
    "name": "$predict_grade",
    "type": "string"
  },
  {
    "name": "$predict_score",
    "type": "number"
  },
  {
    "name": "$radio",
    "displayName": "Radio",
    "description": "The current cellular network communication standard.",
    "type": "string",
    "exampleValue": "3G, 4G, LTE"
  },
  {
    "name": "$referrer",
    "displayName": "Referrer",
    "description": "The referring URL, including your own domain.",
    "type": "string",
    "exampleValue": "https://mixpanel.com/example, https://mixpanel.com/example/segmentation"
  },
  {
    "name": "$referring_domain",
    "displayName": "Referring Domain",
    "description": "The referring domain, including your own domain.",
    "type": "string",
    "exampleValue": "www.google.com, www.mixpanel.com"
  },
  {
    "name": "$responses",
    "type": "list"
  },
  {
    "name": "$screen_dpi",
    "displayName": "Screen DPI",
    "description": "The pixel density of the device screen.",
    "type": "number",
    "exampleValue": "420"
  },
  {
    "name": "$screen_height",
    "displayName": "Screen Height",
    "description": "The height of a device's screen.",
    "type": "number",
    "exampleValue": "960"
  },
  {
    "name": "$screen_width",
    "displayName": "Screen Width",
    "description": "The width of the screen of the device.",
    "type": "number",
    "exampleValue": "360"
  },
  {
    "name": "$screenX",
    "displayName": "[Auto] Screen X",
    "description": "The X-coordinate of the mouse pointer relative to the screen.",
    "type": "number",
    "exampleValue": "100"
  },
  {
    "name": "$screenY",
    "displayName": "[Auto] Screen Y",
    "description": "The Y-coordinate of the mouse pointer relative to the screen.",
    "type": "number",
    "exampleValue": "100"
  },
  {
    "name": "$scroll_checkpoint",
    "displayName": "[Auto] Scroll Checkpoint",
    "description": "The percentage of scrollbar that has been reached when crossing specific thresholds.",
    "type": "number",
    "exampleValue": "25, 50, 75, 100"
  },
  {
    "name": "$scroll_height",
    "displayName": "[Auto] Scroll Height",
    "description": "The height of the scrollable area of the page.",
    "type": "number",
    "exampleValue": "1000"
  },
  {
    "name": "$scroll_percentage",
    "displayName": "[Auto] Scroll Percentage",
    "description": "The percentage of the page that has been scrolled.",
    "type": "number",
    "exampleValue": "100"
  },
  {
    "name": "$scroll_top",
    "displayName": "[Auto] Scroll Top",
    "description": "The number of pixels that the page has been scrolled vertically.",
    "type": "number",
    "exampleValue": "100"
  },
  {
    "name": "$search_engine",
    "displayName": "Search Engine",
    "description": "The search engine that was used to arrive at your domain.",
    "type": "string",
    "exampleValue": "Google, Yahoo"
  },
  {
    "name": "$survey_collections",
    "description": "Deprecated",
    "type": "list"
  },
  {
    "name": "$survey_responses",
    "type": "list"
  },
  {
    "name": "$survey_shown",
    "displayName": "Survey Shown"
  },
  {
    "name": "$surveys",
    "displayName": "Surveys Received",
    "description": "Deprecated",
    "type": "list"
  },
  {
    "name": "$swift_lib_version",
    "displayName": "Swift Lib Version",
    "description": "The Mixpanel library this is used to send this data.",
    "type": "string",
    "exampleValue": "2.7.6"
  },
  {
    "name": "$tap_action_type",
    "displayName": "Tap Action Type",
    "description": "The type of action that was taken when a notification was tapped.",
    "type": "string",
    "exampleValue": "homescreen, browser, deeplink"
  },
  {
    "name": "$tap_action_uri",
    "displayName": "Tap Action URI",
    "description": "The URI that was opened when a push notification was tapped.",
    "type": "string",
    "exampleValue": "https://mixpanel.com/"
  },
  {
    "name": "$tap_target",
    "displayName": "Tap Target",
    "description": "The item that the user interacted with when the push notification was tapped.",
    "type": "string",
    "exampleValue": "notification, button"
  },
  {
    "name": "$target",
    "displayName": "[Auto] Target",
    "description": "The specific HTML element that triggered the event (e.g., a button or link).",
    "type": "object"
  },
  {
    "name": "$time",
    "displayName": "Time",
    "description": "A unix time epoch that is used to determine the time of an event. If no time property is provided, we will use the time the event arrives at our servers.",
    "type": "datetime",
    "exampleValue": "2011-01T00:00:00Z"
  },
  {
    "name": "time",
    "displayName": "Time",
    "description": "A unix time epoch that is used to determine the time of an event. If no time property is provided, we will use the time the event arrives at our servers.",
    "type": "datetime",
    "exampleValue": "2011-01T00:00:00Z"
  },
  {
    "name": "$title",
    "displayName": "Title",
    "description": "The value of the title attribute of an element.",
    "exampleValue": "Index Page"
  },
  {
    "name": "$transactions",
    "displayName": "Transactions",
    "description": "The list with specially formatted JSON objects, one for each purchase or transaction associated with a specific profile.",
    "type": "object",
    "exampleValue": "{ \"$append\": { \"$transactions\": { \"$time\": \"2016-01-03T09:00:00\", \"$amount\": 20.00 } }"
  },
  {
    "name": "$unsubscribed",
    "displayName": "Unsubscribed",
    "description": "If this property is set to any value, a user will be unsubscribed from Mixpanel email messages.",
    "type": "boolean",
    "exampleValue": "true"
  },
  {
    "name": "$user_agent",
    "displayName": "User Agent",
    "description": "The raw User Agent string sent by the device sending the event.",
    "type": "string",
    "exampleValue": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36"
  },
  {
    "name": "$user_id",
    "displayName": "User ID",
    "description": "A default Mixpanel property to track the $identified_id passed into identify method client-side. Stored locally on the user's device using the register method.",
    "type": "string",
    "exampleValue": "123abc"
  },
  {
    "name": "$username",
    "displayName": "Username",
    "description": "Then name of a user who signed up for your product or service.",
    "type": "string",
    "exampleValue": "Michelle Robinson"
  },
  {
    "name": "$viewportHeight",
    "displayName": "[Auto] Viewport Height",
    "description": "The height of the browser's viewport at the time of the event.",
    "type": "number",
    "exampleValue": "600"
  },
  {
    "name": "$viewportWidth",
    "displayName": "[Auto] Viewport Width",
    "description": "The width of the browser's viewport at the time of the event.",
    "type": "number",
    "exampleValue": "800"
  },
  {
    "name": "$watch_model",
    "displayName": "Watch Model",
    "description": "The model of the iOS watch.",
    "type": "string",
    "exampleValue": "Apple Watch Series 4"
  },
  {
    "name": "$warehouse_import_id",
    "displayName": "Warehouse Import ID",
    "description": "The ID of the recurring Warehouse Import that this data came from.",
    "type": "string",
    "hidden": true
  },
  {
    "name": "$warehouse_import_job_id",
    "displayName": "Warehouse Import Job ID",
    "type": "string",
    "hidden": true,
    "mixpanelHidden": true
  },
  {
    "name": "$warehouse_type",
    "displayName": "Warehouse Type",
    "description": "The name of the warehouse this data was imported from.",
    "exampleValue": "BigQuery",
    "type": "string",
    "hidden": true
  },
  {
    "name": "$warehouse_table",
    "displayName": "Warehouse Table",
    "description": "The name of the warehouse table or view this data was imported from.",
    "type": "string",
    "hidden": true
  },
  {
    "name": "$warehouse_import_run_id",
    "displayName": "Warehouse Import Run ID",
    "type": "string",
    "hidden": true
  },
  {
    "name": "$watch_model",
    "displayName": "Watch Model",
    "description": "The model of the iOS watch.",
    "type": "string",
    "exampleValue": "Apple Watch Series 4"
  },
  {
    "name": "$webdashv2",
    "type": "boolean"
  },
  {
    "name": "$wifi",
    "displayName": "Wifi",
    "description": "The wifi connectivity is enabled. Set to true if Wifi is connected, false if not.",
    "type": "boolean",
    "exampleValue": "true"
  },
  {
    "name": "$x",
    "displayName": "[Auto] X Coordinate",
    "description": "The X-coordinate of the event, often synonymous with $pageX.",
    "type": "number",
    "exampleValue": "100"
  },
  {
    "name": "$y",
    "displayName": "[Auto] Y Coordinate",
    "description": "The Y-coordinate of the event, often synonymous with $pageY.",
    "type": "number",
    "exampleValue": "100"
  },
  {
    "name": "alias",
    "displayName": "Alias",
    "description": "Internal Mixpanel property to track the alias passed into the alias method.",
    "type": "string",
    "exampleValue": "123abc",
    "hidden": true
  },
  {
    "name": "bucket",
    "displayName": "Bucket",
    "description": "A reserved property that is hidden from the Mixpanel interface, and will cause other events to not appear in the interface. Do not name any property bucket or $bucket."
  },
  {
    "name": "collection_id",
    "displayName": "Collection ID"
  },
  {
    "name": "current_domain",
    "displayName": "Current Domain",
    "description": "The domain of the current web page on which the event is fired.",
    "type": "string",
    "exampleValue": "docs.mixpanel.com, www.google.com, segment.com"
  },
  {
    "name": "current_page_title",
    "displayName": "Page Title",
    "description": "The title of the current web page retrieved from document.title and typically viewable in the top bar or tab in a web browser.",
    "type": "string"
  },
  {
    "name": "current_url_path",
    "displayName": "URL Path",
    "description": "The path portion of the current page’s URL, sometimes called a route, retrieved from the window.location.pathname property.",
    "type": "string"
  },
  {
    "name": "current_url_protocol",
    "displayName": "URL Protocol",
    "description": "The protocol of the current page view request.",
    "type": "string",
    "exampleValue": "http, https"
  },
  {
    "name": "current_url_search",
    "displayName": "URL Search",
    "description": "The query parameter portion of the current page’s URL retrieved from the window.location.search property",
    "type": "string"
  },
  {
    "name": "distinct_id",
    "displayName": "Distinct ID",
    "description": "Internal Mixpanel property to track the the distinct_id passed into alias method.",
    "type": "string",
    "exampleValue": "123abc",
    "hidden": true,
    "isSensitiveBlacklisted": true
  },
  {
    "name": "has_nfc",
    "displayName": "Has NFC",
    "description": "The device supports Near Field Communication(NFC). Set to true if the device has NFC, false if not.",
    "type": "boolean",
    "exampleValue": "true"
  },
  {
    "name": "initial_utm_campaign",
    "displayName": "Initial UTM Campaign",
    "description": "The utm_campaign value from the first UTM parameters ever seen for a customer when they arrive at your site.",
    "type": "string",
    "exampleValue": "summer-sale, new-product-release"
  },
  {
    "name": "initial_utm_content",
    "displayName": "Initial UTM Content",
    "description": "The utm_content value from the first UTM parameters ever seen for a customer when they arrive at your site.",
    "type": "string",
    "exampleValue": "pricing, sales"
  },
  {
    "name": "initial_utm_medium",
    "displayName": "Initial UTM Medium",
    "description": "The utm_medium value from the first UTM parameters ever seen for a customer when they arrive at your site.",
    "type": "string",
    "exampleValue": "blog, social, organic"
  },
  {
    "name": "initial_utm_source",
    "displayName": "Initial UTM Source",
    "description": "The utm_source value from the first UTM parameters ever seen for a customer when they arrive at your site.",
    "type": "string",
    "exampleValue": "google, linkedin, facebook"
  },
  {
    "name": "initial_utm_term",
    "displayName": "Initial UTM Term",
    "description": "The utm_term value from the first UTM parameters ever seen for a customer when they arrive at your site.",
    "type": "string"
  },
  {
    "name": "ip",
    "displayName": "IP",
    "description": "If distinct_id is not present, and the event contains a property named 'ip', the value of 'ip' will be used for uniqueness.",
    "type": "string",
    "exampleValue": "72.47.27.113"
  },
  {
    "name": "mp_browser",
    "displayName": "Browser",
    "description": "The name of the browser. (Not versioned)",
    "type": "string",
    "exampleValue": "Chrome, Firefox"
  },
  {
    "name": "mp_country_code",
    "displayName": "Country",
    "description": "The country of the event sender, parsed from IP.",
    "type": "string",
    "exampleValue": "United States, Canada"
  },
  {
    "name": "mp_device_model",
    "displayName": "Device Model",
    "description": "The legacy device model ID.",
    "type": "string",
    "exampleValue": "iPhone"
  },
  {
    "name": "mp_keyword",
    "displayName": "Search Keyword",
    "description": "The search keywords detected on the referrer from a search engine to your domain. This property is only collected when search keywords are included in a URL.",
    "type": "string",
    "exampleValue": "Mixpanel"
  },
  {
    "name": "mp_lib",
    "displayName": "Mixpanel Library",
    "description": "The name of the Mixpanel Library that sent the event.",
    "type": "string",
    "exampleValue": "Web, Android, iPhone"
  },
  {
    "name": "mp_page",
    "displayName": "Page View"
  },
  {
    "name": "mp_platform",
    "displayName": "Platform",
    "description": "The information about the operating system's platform.",
    "type": "string",
    "exampleValue": "Android, iOS, Mac OS"
  },
  {
    "name": "mp_processing_time_ms",
    "displayName": "Time Processed (UTC)",
    "description": "Time in milliseconds in Unix Time Stamp when an event was ingested by Mixpanel. While the \"Time\" property in Mixpanel is set in the time zone specified by the project, mp_processing_time_ms will always be in UTC (GMT) time.",
    "type": "number",
    "exampleValue": "1543546310165",
    "hidden": true
  },
  {
    "name": "mp_referrer",
    "displayName": "Referrer",
    "description": "The URL of the document that loaded the current document.",
    "type": "string",
    "exampleValue": "https://www.google.com/"
  },
  {
    "name": "mp_sent_by_lib_version",
    "displayName": "Sent By Library Version",
    "description": "Version of the Mixpanel library used to send this data over the network (not necessarily the same as the version which enqueued the data).",
    "type": "string",
    "exampleValue": "5.4.1"
  },
  {
    "name": "sent_to",
    "displayName": "Sent To"
  },
  {
    "name": "survey_id",
    "displayName": "Survey ID"
  },
  {
    "name": "token",
    "displayName": "Token",
    "description": "The token used to associate data you send Mixpanel to your account and project.",
    "type": "string",
    "exampleValue": "89ffb64cee3d1b77b47c7c83225fa50e"
  },
  {
    "name": "gclid",
    "displayName": "gclid",
    "description": "The tag named 'gclid' in the URL link a customer clicked to arrive at your domain.",
    "type": "string"
  },
  {
    "name": "fbclid",
    "displayName": "fbclid",
    "description": "The tag named 'fbclid' in the URL link a customer clicked to arrive at your domain.",
    "type": "string"
  },
  {
    "name": "dclid",
    "displayName": "dclid",
    "description": "The tag named 'dclid' in the URL link a customer clicked to arrive at your domain.",
    "type": "string"
  },
  {
    "name": "ko_click_id",
    "displayName": "ko_click_id",
    "description": "The tag named 'ko_click_id' in the URL link a customer clicked to arrive at your domain.",
    "type": "string"
  },
  {
    "name": "li_fat_id",
    "displayName": "li_fat_id",
    "description": "The tag named 'li_fat_id' in the URL link a customer clicked to arrive at your domain.",
    "type": "string"
  },
  {
    "name": "msclkid",
    "displayName": "msclkid",
    "description": "The tag named 'msclkid' in the URL link a customer clicked to arrive at your domain.",
    "type": "string"
  },
  {
    "name": "sccid",
    "displayName": "sccid",
    "description": "The tag named 'sccid' in the URL link a customer clicked to arrive at your domain.",
    "type": "string"
  },
  {
    "name": "ttclid",
    "displayName": "ttclid",
    "description": "The tag named 'ttclid' in the URL link a customer clicked to arrive at your domain.",
    "type": "string"
  },
  {
    "name": "twclid",
    "displayName": "twclid",
    "description": "The tag named 'twclid' in the URL link a customer clicked to arrive at your domain.",
    "type": "string"
  },
  {
    "name": "wbraid",
    "displayName": "wbraid",
    "description": "The tag named 'wbraid' in the URL link a customer clicked to arrive at your domain.",
    "type": "string"
  },
  {
    "name": "$event_version",
    "hidden": true,
    "mixpanelHidden": true
  },
  {
    "name": "mp_original_distinct_id",
    "displayName": "Hotshard Original Distinct ID",
    "description": "Original distinct id for an event that was identified as contributing to a hotshard.",
    "type": "string",
    "exampleValue": "166424e227e7fb-0ff2f469b2f1fc-2d6a4f35"
  },
  {
    "name": "mp_original_event_name",
    "displayName": "Hotshard Original Event Name",
    "description": "Original event name for an event that was identified as contributing to a hotshard.",
    "type": "string",
    "exampleValue": "Song Played"
  },
  {
    "name": "$mp_actor_name",
    "displayName": "Actor Name",
    "description": "The name of the AI bot or crawler that generated this event, when the actor is not a human.",
    "type": "string",
    "exampleValue": "ChatGPT-User"
  },
  {
    "name": "$mp_actor_type",
    "displayName": "Actor Type",
    "description": "Whether this event was classified by Mixpanel as none, an agent, or a bot.",
    "type": "string",
    "exampleValue": "agent"
  },
  {
    "name": "$mp_raw_user_agent",
    "displayName": "Raw User Agent",
    "description": "The unparsed User Agent string associated with the event.",
    "type": "string",
    "exampleValue": "Mozilla/5.0 AppleWebKit/537.36 (KHTML, like Gecko); compatible; ChatGPT-User/1.0; +https://openai.com/bot"
  }
]
